import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ServiceConstant } from '../utils/service-constant.util';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TogoService {
  httpClient = inject(HttpClient);

  constructor() {}

  getTogos(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/restaurants/togos').pipe(
      catchError((error) => {
        console.error('Error fetching togos:', error);
        return of(error);
      }),
    );
  }

  createTogo(togo: any): Observable<any> {
    return this.httpClient.post<any>(ServiceConstant.apiUrl + '/restaurants/togos', togo).pipe(
      catchError((error) => {
        console.error('Error creating togo:', error);
        return of(error);
      }),
    );
  }
}
